import { QDiagnosticOut } from "../CoreApp/QDiagnosticOut";
import { addMissingValue } from "./addMissingValue";
import { getBase64Image } from "./getBase64Image";
import { GetNameDefForObj } from "./GetNameDefForObj";

export function MissingPicLoad() {
  var missingImage64 = getBase64Image(this); //anImage
  var curDoc = this["curdoc"];
  var wsMgr = this["wsmgr"];
  var w = parseInt(this["x0"]);
  var h = parseInt(this["y0"]);

  var missingList = curDoc.GetMissingPicList(missingImage64, w, h);

  var curOrg = wsMgr.GetAccountName();
  var curUser = wsMgr.GetUserName();

  var dOut = new QDiagnosticOut();
  var s = "MissingPhotos.xls";
  dOut.Init(curOrg, curUser, s, wsMgr);
  var n = missingList.length;
  var photoDef, idDef, nameDef;

  if (n > 0) {
    var o = missingList[0];
    photoDef = o.GetFieldDefByID("Photo");
    idDef = o.GetRecordIDFieldDef(true);
    nameDef = GetNameDefForObj(o);
  }
  var fieldData = [];
  dOut.fHeaders = ["PersonID", "Name", "Photo"];
  var jsonData = {
    rows: dOut.fRowList,
    headers: dOut.fHeaders,
    headerLabels: dOut.fHeaders
  };
  for (var aHeader in dOut.fHeaders) fieldData.push({ name: dOut.fHeaders[aHeader], type: 0 });

  for (var i = 0; i < n; i++) {
    var aList = [];
    var o = missingList[i];
    addMissingValue(aList, o, idDef);
    addMissingValue(aList, o, nameDef);
    addMissingValue(aList, o, photoDef);
    dOut.AddDataRow(aList);
  }
  jsonData["datatypes"] = fieldData;
  jsonData["filename"] = dOut.fFilename.replace(".xls", "");
  jsonData["sheetname"] = "User Information List";
  dOut.UploadExcelDataJSON(jsonData);
}
